export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "${str}": "",
        "Administracja": "",
        "Akceptuj": "",
        "Aktywne kanały komunikacji": "",
        "Anuluj": "",
        "Błąd w kodzie MJML.": "",
        "Brak nowych powiadomień.": "",
        "Centrum powiadomień": "",
        "Data otrzymania": "",
        "Data utworzenia": "",
        "Data wysłania": "",
        "Dodaj szablon": "",
        "Dodaj typ": "",
        "Dodaj wiadomość": "",
        "Dodaj zmienne dla szablonu": "",
        "Dodane przez": "",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "",
        "Edytuj": "",
        "Edytuj szablon": "",
        "Edytuj typ": "",
        "Edytuj wiadomość": "",
        "Id": "",
        "ID": "",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "",
        "kanał wymagany": "",
        "Kanały": "",
        "Kanały komunikacji": "",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "",
        "Kanały włączone w ustawieniach aplikacji": "",
        "Kategoria": "",
        "Klucze": "",
        "Kod MJML": "",
        "Konfiguracja domyślna": "",
        "Konfiguracja stopki oraz logo umieszczanych w wysyłanych powiadomieniach kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "",
        "Kopiuj": "",
        "Lista jest pusta": "",
        "Logo": "",
        "Moje dokumenty": "",
        "Nazwa": "",
        "Nazwa powiadomienia": "",
        "Nazwa szablonu": "",
        "Nazwa typu": "",
        "Nazwa zmiennej nie może być pusta.": "",
        "Nie udało się pobrać listy kanałów": "",
        "Nie udało się pobrać listy powiadomień": "",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się wykonać akcji": "",
        "Nie znaleziono żadnych wyników.": "",
        "Odznacz": "",
        "Odznacz wszystkie": "",
        "Oznacz": "",
        "Oznacz jako nieprzeczytane": "",
        "Oznacz jako przeczytane": "",
        "Oznacz powiadomienia": "",
        "Oznacz wszystkie jako przeczytane": "",
        "Oznacz wybrane jako nieprzeczytane": "",
        "Oznacz wybrane jako przeczytane": "",
        "Poczta wychodząca": "",
        "Podgląd HTML": "",
        "Podgląd szablonu": "",
        "Pokaż w koncie użytkownika": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdź akceptację": "",
        "Powiadomienia": "",
        "Powiadomienia mailowe": "",
        "Powiadomienia zostały skonfigurowane.": "",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiadomienie zbiorowe zostało dodane.": "",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "",
        "Powiększ kod MJML": "",
        "Powiększ podgląd": "",
        "Powrót": "",
        "Stan powiadomienia": "",
        "Status dokumentu został zmieniony.": "",
        "Status powiadomienia": "",
        "Stopka": "",
        "Strona główna": "",
        "System": "",
        "System powiadomień": "",
        "Szablon został dodany.": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony email": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "",
        "Testuj": "",
        "Treść": "",
        "Typ powiadomienia": "",
        "Typy powiadomień": "",
        "Tytuł": "",
        "Tytuł powiadomienia": "",
        "Ustawienia": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Usuń": "",
        "Wersje": "",
        "Włączone": "",
        "Włączony": "",
        "Wpis do kalendarza został usunięty.": "",
        "Wszystko": "",
        "wybierz": "",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "",
        "wybierz...": "",
        "Wybór języka": "",
        "Wyłączony": "",
        "Wymagane": "",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "",
        "Wysyłaj tym kanałem": "",
        "Wysyłka wiadomości": "",
        "Wyślij do": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zapisz ustawienia": "",
        "Zaznacz": "",
        "Zaznacz wszystkie": "",
        "Zmiana hasła": "",
        "Zmienne": "",
        "Zobacz wszystkie": "",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": ""
    }
};
